import { makeStyles } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';
import React, { useContext } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import Footer, { footerHeight } from 'components/Footer';
import Header from 'components/Header';
import { drawerWidthClosed, drawerWidthOpened } from '../../components/Menu/AdministrationMenu';
import { colors } from '../../theme';
import { MenuContext } from '../../menuContext';
import { drawerWidthOpenedSubMenu } from '../../components/Menu/Menu';
import Menu from '../../components/MenuCiteo/MenuListAdmin';

const useStyles = makeStyles(theme => ({
  content: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',

    paddingLeft: '2rem',
    paddingRight: '2rem',
    marginBottom: footerHeight,
    paddingTop: '8.4rem',
    background: 'linear-gradient(313.13deg, #F5F5F5 39.8%, #FFFFFF 62.33%)',
    minHeight: 'calc(100vh - 20px)',

    '& h2': {
      marginTop: 0,
    },
  },
  contentMenuOpen: {
    marginLeft: drawerWidthOpened,
  },
  contentNoMenu: {
    marginLeft: 0,
    paddingLeft: 0,
  },
  contentMenuClosed: {
    marginLeft: drawerWidthClosed,
  },
  title: {
    marginBottom: '1rem',
  },
  link: {
    textTransform: 'uppercase',
    fontSize: '0.75rem',
    textDecoration: 'underline',
    color: colors.neutral800,
  },
  linkContainer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
  },
  separator: {
    borderRight: `1px solid ${colors.neutral800}`,
    paddingRight: 7,
    marginRight: 7,
  },
  contentMenuOpenWithSubMenu: {
    marginLeft: drawerWidthOpenedSubMenu,
  },
}));

interface Props {
  noMenu?: boolean;
  children?: any;
}

const AdministrationLayout: React.FC<Props> = ({ noMenu, children }) => {
  const classes = useStyles();
  const { open, submenuIsOpen } = useContext(MenuContext);

  const { t } = useTranslation();

  const contentClasses = [
    classes.content,
    !noMenu &&
      (open && !submenuIsOpen
        ? classes.contentMenuOpen
        : submenuIsOpen
        ? classes.contentMenuOpenWithSubMenu
        : classes.contentMenuClosed),
    noMenu && classes.contentNoMenu,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <>
      <Header />
      {!noMenu && <Menu />}
      <div className={contentClasses}>
        <ErrorBoundary
          fallbackRender={({ error }) => (
            <Alert severity="error">
              <AlertTitle>{t('errorGeneric')}</AlertTitle>
              <pre>{error.message}</pre>
            </Alert>
          )}
        >
          {children}
        </ErrorBoundary>
      </div>
      <Footer />
    </>
  );
};

export default React.memo(
  AdministrationLayout,
  (prevProps, nextProps) => prevProps.noMenu === nextProps.noMenu && prevProps.children === nextProps.children,
);
